<template>
  <div module-item :class="info.type">
    <div class="left">
      <cdn-img :src="info.value.img.pc" class="hidden-ml-down"/>
      <cdn-img :src="info.value.img.mobile" class="hidden-tp-up"/>
    </div>
    <div class="right">
      <div class="subtitle-text">
        <div class="title">
          <i></i>
          <h5 v-html="enterToBr(info.value.title)"></h5>
        </div>
        <div class="body-text" v-html="info.value.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CdnImg from '@/views/components/CdnImg';

export default {
  name: 'DoubleImageText',
  components: { CdnImg },
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
};
</script>

